import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomTitleComponent } from './custom-title.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [
    CustomTitleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
  ],
  exports: [
    CustomTitleComponent
  ]
})
export class CustomTitleModule { }
